<template>
  <div class="home-main">
    <step-breadcrumb/>
    <advance-search/>
    <available-hotels/>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import util from '@/util';
import AdvanceSearch from '@/components/AdvanceSearch.vue'
import StepBreadcrumb from '@/components/StepBreadcrumb.vue'
import AvailableHotels from '@/components/AvailableHotels.vue'

export default {
  name: 'Home',
  components: {
    AdvanceSearch,
    StepBreadcrumb,
    AvailableHotels
  },
  data () {
    return {
      publicPath: process.env.BASE_URL
    }
  },
  methods: {
    gaEvent() {
      let gaData = {
        currentTimeMacau: localStorage.date || '',
        currentTimeLocal: util.dateStr(new Date(), true),
        currentStep: 1,
        cookieId: '',
        skinCode: this.gaData.skinCode,
        memberLoggedIn: false,
      }

      window.dataLayer.push(gaData)
      window._mtm.push({"event": "booking data ready"})
    }
  },
  created() {
    //this.$root.$children[0].gaInit()
    localStorage.removeItem("selects")
    localStorage.removeItem("room")
    if (this.$route.query.skin) {
      const skinCode = this.$route.query.skin
      localStorage.skinCode = skinCode
      this.$store.commit('stateChange', {k: 'gaData', v: Object.assign({}, this.gaData, {skinCode})})
      if (skinCode == 'sjm') {
        document.head.getElementsByTagName('link')[0].href=`${this.publicPath}sjmfavicon.ico`
      } else if (skinCode == 'gl') {
        document.head.getElementsByTagName('link')[0].href=`${this.publicPath}glfavicon.ico`
      } else {
        document.head.getElementsByTagName('link')[0].href=`${this.publicPath}glpfavicon.ico`
      }
    }
    if (this.dataLayerReady) {
      this.gaEvent()
    }
  },
  computed: {
    ...mapState([
      'dataLayerReady',
      'gaData'
    ]),
  },
  watch: {
    dataLayerReady(isReady) {
      if (isReady) {
        this.gaEvent()
      }
    }
  }
}
</script>
